<script setup>
import { trans } from '@elements/translation';

const emit = defineEmits([ 'click' ]);
</script>

<template>
  <button
    class="show-map-button"
    @click.prevent="emit('click')"
  >
    <span>{{ trans('selection_item.view.map') }}</span>
  </button>
</template>
